<template>
    <div class="upload-works">
        <div class="aside">
            <div class="upload-works__title">上传封面</div>
            <el-upload
                class="cover-uploader"
                ref="upload"
                action="/TobDesign/api/article/uploadImage"
                :show-file-list="false"
                :on-success="handleCoverSuccess"
                :before-upload="beforeCoverUpload"
                accept="image/jpeg,image/jpg,image/png"
                title="建议上传最佳尺寸600*400px，不超过500kb"
            >
                <img v-if="form.logo" :src="form.logo" class="cover-image">
                <div class="cover-uploader__wrapper" v-else>
                    <svg-icon
                        icon-class="upload"
                        class-name="icon-upload"
                    ></svg-icon>
                    <div class="des">建议上传最佳尺寸</div>
                    <div class="des">600*400px，不超过5MB</div>
                </div>
            </el-upload>
        </div>
        <div class="upload-works__content">
            <el-form :model="form" :rules="rules" ref="form" name="uploadWorks" key="uploadWorks"  class="upload-works__form">
                <div class="upload-works__form-item">
                    <el-row>
                        <el-col :span="12">
                            <div class="upload-works__title">标题</div>
                            <el-form-item prop="title">
                                <el-input
                                    class="upload-works__title__input"
                                    :maxlength="50"
                                    show-word-limit
                                    v-model="form.title"
                                />
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <div style="margin-left: 15px">
                                <div class="upload-works__title">分类</div>
                                <el-form-item prop="flIdList">
                                    <el-select multiple v-model="form.flIdList" style="width: 100%">
                                        <el-option
                                            v-for="item in selectOptions.flIdList"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div style="margin-left: 15px">
                                <div class="upload-works__title">标签</div>
                                <el-form-item prop="labelId">
                                    <el-select v-model="form.labelId" style="width: 100%">
                                        <el-option
                                            v-for="item in selectOptions.bqId"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-col>
                        <!-- <el-col :span="4">
                            <div style="margin-left: 15px">
                                <div class="upload-works__title">行业</div>
                                <el-form-item prop="industryId">
                                    <el-select v-model="form.industryId" style="width: 100%">
                                        <el-option
                                            v-for="item in selectOptions.hyId"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-col> -->
                    </el-row>
                </div>
                <div class="upload-works__form-item">
                    <div class="upload-works__title">简介</div>
                    <el-form-item prop="introduction">
                        <el-input
                            type="textarea"
                            :maxlength="200"
                            show-word-limit
                            v-model="form.introduction"
                            :autosize="{ minRows: 4, maxRows: 8 }"
                        />
                    </el-form-item>
                </div>
                <div class="upload-works__form-item">
                    <div class="upload-works__title">
                        <span>上传视频</span>
                        <span class="description">（最多上传3个视频，单个视频不超过500M）</span>
                    </div>
                    <div class="image-uploader__wrapper video__wrapper">
                        <el-upload
                            ref="videoUploader"
                            action=""
                            :file-list="videoList"
                            :disabled="isUploading"
                            :limit=3
                            :before-upload="beforeVideoUpload"
                            :http-request="uploadRequest"
                            :on-exceed="handleExceed"
                            :on-change="handleChangeIcon"
                            :on-remove="handlVideoRemove"
                            accept="video/*"
                        >
                            <el-button type="primary">上传视频</el-button>
                        </el-upload>
                    </div>
                </div>
                <div class="upload-works__form-item">
                    <div class="upload-works__title">
                        <span>上传图片</span>
                        <span class="description">（支持拖拽排序，单张图大小不超过20M，最多上传80张图片）</span>
                    </div>
                    <div class="image-uploader__wrapper image__wrapper">
                        <el-upload
                            ref="pictureUploader"
                            action="/TobDesign/api/file/uploadLocal?type=work" 
                            list-type="picture-card"
                            multiple
                            :file-list="fileList"
                            :before-upload="beforePictureUpload"
                            :on-preview="handlePicturePreview"
                            :on-change="handlePictureChange"
                            :on-remove="handlPictureRemove"
                            accept="image/jpeg,image/jpg,image/png,image/gif"
                        >
                            <svg-icon
                                icon-class="upload"
                                class-name="icon-upload"
                            ></svg-icon>
                        </el-upload>
                    </div>
                </div>
                <div class="form-btns">
                    <el-button type="primary" class="form-button" :loading="submitLoading" @click="handleSubmit(1)">立即发布</el-button>
                    <el-button type="primary" plain class="form-button" @click="handlePreview">预览作品</el-button>
                    <el-button type="primary" plain class="form-button" @click="handleSubmit(2)">保存草稿</el-button>
                </div>
            </el-form>
        </div>
        <!-- 预览 -->
        <PreviewWork v-if="dialogVisible" :visible.sync="dialogVisible" :title="form.title" :introduction="form.introduction" :videoList="form.video ? form.video.split(',') : []" :pictureList="form.urlList" @handleSubmit="handleSubmit(1)"></PreviewWork>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import AliOSS from 'ali-oss';
import Sortable from 'sortablejs';
import { getWorkTabs, getUserZuoPinDetail, addWork, editWork } from '@/api/works';
import { getOSSConfig } from '@/api/common';
import PreviewWork from './PreviewWork';
// import aliOSS from '@/utils/aliOSS';
export default {
    name: 'UploadWorks',
    components: {
        PreviewWork
    },
    inject: ['interceptLeave'],
    data: () => ({
        mode: 'add',
        selectOptions: {
            flIdList: [],
            bqId: [],
            hyId: []
        },
        isUploading: false,
        videoList: [],
        fileList: [],
        fileListLen: 0,
        detailId: null,
        form: {
            title: '',
            flIdList: [],
            // industryId: null,
            labelId: 36,
            introduction: '',
            logo: null,
            urlList: []
        },
        rules: {
            title: [
                { required: true, message: '请输入标题', trigger: 'blur' },
                { min: 2, max: 50, message: '标题长度为2-50位', trigger: ['blur', 'change'] },
                // {
                //     pattern: /^[\S]{2,50}$/,
                //     message: '标题不支持空格哦',
                //     trigger: ['blur', 'change']
                // }
            ],
            flIdList: [
                { required: true, message: '请选择分类', trigger: 'blur' }
            ],
            labelId: [
                { required: true, message: '请选择标签', trigger: 'blur' }
            ],
            // industryId: [
            //     { required: true, message: '请选择行业', trigger: 'blur' }
            // ]
        },
        dialogVisible: false,
        submitLoading: false,
        submitAction: false,
        isUpdate: false,
    }),
    computed: {
        ...mapState('user', ['userInfo'])
    },
    beforeRouteLeave(to, from, next) {
        if (!this.submitAction && !this.isEmptyForm()) {
            setTimeout(() => {
                this.$confirm('当前页面已有内容，是否确认离开此页面？')
                    .then(() => {
                        next(true);
                    })
                    .catch(() => {
                        next(false);
                    });
            }, 200)
        } else {
            next();
        }
    },
    created() {
        window.addEventListener('beforeunload', this.listenInterceptLeave);
    },
    mounted() {
        this.cardDrop();
        this.getOptions();
        const { id } = this.$route.query;
        if (id) {
            this.mode = 'edit';
            this.detailId = id;
            this.getWorkDetail(id);
        }
    },
    destroyed() {
        window.removeEventListener('beforeunload', this.listenInterceptLeave);
    },
    methods: {
        listenInterceptLeave(e) {
            this.interceptLeave(e, !this.submitAction && !this.isEmptyForm());
        },
        isEmptyForm() {
            if (
                this.form.title === '' &&
                this.form.introduction === '' &&
                this.form.logo === null &&
                this.form.urlList.length === 0 && !this.fileListLen &&
                !this.form.video && this.videoList.length === 0
            ) {
                return true;
            }
            return false;
        },
        // 获取作品详情
        getWorkDetail(id) {
            getUserZuoPinDetail({ zId: id, userId: this.userInfo.id }).then(({ code, data }) => {
                if (code === 0) {
                    this.form.title = data.title;
                    this.form.introduction = data.introduction;
                    this.form.logo = data.logo;
                    this.form.flIdList = data.flIdList || [];
                    this.form.labelId = data.labelId;
                    // this.form.industryId = data.industryId;
                    this.form.urlList = data.pictureList.map(({ address }) => {
                        return address;
                    });
                    this.fileList = data.pictureList.map(({ address }) => {
                        return {
                            name: '图片',
                            url: address
                        };
                    });
                    this.videoList = data.video.split(',').map((url) => {
                        return {
                            name: decodeURI(url.split('/').pop()),
                            url
                        };
                    });
                    this.handleChangeIcon();
                }
            });
        },
        getOptions() {
            // 获取作品分类
            getWorkTabs({
                type: 1
            }).then(({ data }) => {
                const options = data.map(({ id, name }) => {
                    return {
                        label: name,
                        value: id
                    };
                });
                this.selectOptions.flIdList = [
                    ...options
                ];
            });
            // 获取作品标签
            getWorkTabs({
                type: 3
            }).then(({ data }) => {
                const options = data.map(({ id, name }) => {
                    return {
                        label: name,
                        value: id
                    };
                });
                this.selectOptions.bqId = [
                    ...options
                ];
            });
            // 获取作品行业
            getWorkTabs({
                type: 2
            }).then(({ data }) => {
                const options = data.map(({ id, name }) => {
                    return {
                        label: name,
                        value: id
                    };
                });
                this.selectOptions.hyId = [
                    ...options
                ];
            });
        },
        // 上传封面
        handleCoverSuccess(res) {
            console.log('res: ', res);
            this.form.logo = res.data;
        },
        beforeCoverUpload(file) {
            const isIMG = ['image/jpg', 'image/jpeg', 'image/png', 'image/gif'].includes(file.type);
            const isLt5MB = file.size < 5 * 1024 * 1024;

            if (!isIMG) {
                this.$message.error('请上传图片');
                return false;
            }

            if (!isLt5MB) {
                this.$message.error('上传图片大小不能超过 5MB');
            }
            return isIMG && isLt5MB;
        },
        cardDrop() {
            const wrapper = document.querySelector('.image__wrapper .el-upload-list');
            Sortable.create(wrapper, {
                draggable: '.el-upload-list__item', // 允许拖拽的项目类名
                delay: 0,
                onEnd: evt => {
                    const oldItem = this.fileList[evt.oldIndex];
                    this.fileList.splice(evt.oldIndex, 1);
                    this.fileList.splice(evt.newIndex, 0, oldItem);
                }
            });
        },
        handleChangeIcon(file, fileList) {
            file && this.handleVideoChange(file, fileList);
            this.$nextTick(() => {
                const icons = this.$refs.videoUploader.$el && this.$refs.videoUploader.$el.getElementsByClassName('el-icon-document');

                icons && Array.from(icons).forEach((icon) => {
                    icon.setAttribute("class", 'el-icon-video-play');
                });
            });
        } ,
        // 上传视频前校验
        beforeVideoUpload(file) {
            const isVideo = file.type.indexOf('video') > -1;
            const isLt500M = file.size < 500 * 1024 * 1024;
            if (!isVideo) {
                this.$message.error('请上传视频');
                return false;
            }
            if (!isLt500M) {
                this.$message.error('视频大小不能超过500M');
                return false;
            }
            return isVideo && isLt500M;
        },
        handleVideoChange(file, fileList) {
            this.videoList = fileList;
        },
        // 删除视频
        async handlVideoRemove(file, fileList) {
            this.videoList = fileList;
            let config = await getOSSConfig();
            var client = new AliOSS({
                region: 'oss-cn-chengdu',
                accessKeyId: config.data.accessid,
                accessKeySecret: 'fEenefEpkSzxjT3wsIidFDHRHdslq9',
                bucket: 'shuzixs1',
                policy: config.data.policy,
                signature: config.data.signature,
                secure: true
            });
            client.delete(file.response ? file.response.name : new URL(file.url).pathname);
        },
        // 上传视频
        async uploadRequest (option) {
            try {
                this.isUploading = true;
                let file = option.file;
                let config = await getOSSConfig();
                var client = new AliOSS({
                    region: 'oss-cn-chengdu',
                    accessKeyId: config.data.accessid,
                    accessKeySecret: 'fEenefEpkSzxjT3wsIidFDHRHdslq9',
                    bucket: 'shuzixs1',
                    policy: config.data.policy,
                    signature: config.data.signature,
                    secure: true
                });
                // let client = aliOSS(config.data);
                // 上传文件
                const res = await client.multipartUpload(`${Math.floor(Math.random()*(9999-1000))+9999}/video/` + encodeURI(file.name), file, {
                    progress: async function (p) {
                        let e = {}
                        e.percent = p * 100
                        option.onProgress(e)
                    }
                });
                if (res.res.statusCode === 200) {
                    return res;
                } else {
                    option.onError('上传失败')
                }
            } catch (error) {
                option.onError('上传失败')
                this.$error(error.message)
            } finally {
                this.isUploading = false;
            }
        },
        handleExceed() {
            this.$message.error('视频最多上传3个');
        },
        // 上传作品
        beforePictureUpload(file) {
            const isIMG = ['image/jpg', 'image/jpeg', 'image/png', 'image/gif'].includes(file.type);
            const isLt10M = file.size < 20 * 1024 * 1024;
            const isLt80 = this.fileListLen <= 80;
            if (!isIMG) {
                this.$message.error('请上传图片');
                return false;
            }
            if (!isLt10M) {
                this.$message.error('图片大小不能超过20M');
                return false;
            }
            if (!isLt80) {
                this.$message.error('图片不能超80张');
                return false;
            }
            return isLt10M && isLt80 && isIMG;
        },
        handlePictureChange(file, fileList) {
            this.fileList = fileList;
            this.fileListLen = fileList.length;
        },
        handlPictureRemove(file, fileList) {
            this.fileList = fileList;
            this.fileListLen = fileList.length;
        },
        handlePicturePreview(file) {
            const url = file.url || file.thumbUrl;
            const aTag = document.createElement('a');
            let href = url;
            aTag.href = href;
            aTag.target = '_blank';
            aTag.click();
            return;
        },
        getUrlList() {
            this.form.video = this.$refs.videoUploader.uploadFiles.map(({ url, response }) => {
                return (response && response.name) || url;
            }).join(',');
            this.form.urlList = this.$refs.pictureUploader.uploadFiles.map(({ url, response }) => {
                return  (response && response.data[0]) || url;
            });
        },
        // 预览作品
        handlePreview() {
            this.getUrlList();
            this.dialogVisible = true;
        },
        /**
         * 发布作品
         * @param status 1正式 2草稿
         */
        handleSubmit(status) {
            if (this.isUploading) {
                this.$message.warning('正在上传视频，请稍后发布');
                return;
            }
            this.getUrlList();
            this.$refs.form.validate(valid => {
                if (valid) {
                    if (!this.form.logo) {
                        this.$message.error('请上传封面');
                        return;
                    }
                    console.log(this.form)
                    if (this.form.urlList.length === 0 && !this.form.video) {
                        this.$message.error('请上传图片或视频');
                        return;
                    }
                    const params = {
                        status,
                        publisher: this.userInfo.id,
                        labelName: (this.selectOptions.bqId.find(item => item.value === this.form.labelId) || {}).label,
                        ...this.form
                    };
                    this.submitLoading = true;
                    if (this.mode === 'edit') {
                        params.id = this.detailId;
                        editWork(params).then(({ code }) => {
                            if (code === 0) {
                                this.$message.success(`${status === 1 ? '发布' : '保存'}成功`);
                                this.submitAction = true;
                                this.$router.push({
                                    name: 'User' ,
                                    query: {
                                        type: status === 1 ? 0 : 6
                                    }
                                });
                            }
                        }).finally(() => {
                            this.submitLoading = false;
                        });
                    } else {
                        addWork(params).then(({ code }) => {
                            if (code === 0) {
                                this.$message.success(`${status === 1 ? '发布' : '保存'}成功`);
                                this.submitAction = true;
                                this.$router.push({
                                    name: 'User' ,
                                    query: {
                                        type: status === 1 ? 0 : 6
                                    }
                                });
                            }
                        }).finally(() => {
                            this.submitLoading = false;
                        });
                    }
                }
            });
        },
    }
};
</script>

<style lang="scss">
.upload-works .image-uploader__wrapper {
    .el-upload--picture-card {
        width: 240px;
        height: 160px;
        line-height: 160px;
        border: 1px solid #e0e4f7;
        transition: border-color .5s;
        background: rgba(224, 228, 247, 0.37);

        &:hover {
            border-color: #C0C4CC;
        }
    }
    .el-upload-list--picture-card .el-upload-list__item {
        width: 240px;
        height: 160px;

        .el-icon-close-tip {
            display: none !important;
        }
    }
    .el-upload-list__item .el-progress-bar {
        margin-top: 10px;
    }
}
.video__wrapper {
    .el-upload-list {
        &__item {
            [class^='el-icon-'] {
                font-size: 20px;
            }
        }
    }
}

// 小屏
@include mq($small) {
    .upload-works .image-uploader__wrapper {
        .el-upload--picture-card {
            width: 180px;
            height: 120px;
            line-height: 120px;
        }
        .el-upload-list--picture-card .el-upload-list__item {
            width: 180px;
            height: 120px;
        }
    }
    .el-progress .el-progress-circle {
        margin: 0 auto;
        width: 100px!important;
        height: 100px!important;
    }
}
</style>

<style lang="scss" scoped>
.video__wrapper {
    width: 60%;
}
.upload-works {
    padding-top: 20px;
    display: flex;

    &__title {
        display: flex;
        align-items: center;
        height: 40px;
        line-height: 40px;
        @include font(rgba(38, 42, 63, 1), 14px, 600);

        .description {
            margin-left: 5px;
            @include font(#919191, 12px, 400);
        }
        &__input {
            & /deep/ .el-input__inner {
                padding-right: 50px;
            }
        }
    }

    .aside {
        width: 300px;
        margin-right: 30px;

        .cover-uploader__wrapper {
            position: relative;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 300px;
            height: 200px;
            overflow: hidden;
            background: rgba(224, 228, 247, 0.37);
            border-radius: 6px;
            border: 1px solid #e0e4f7;
            transition: border-color .5s;

            &:hover {
                border-color: #C0C4CC;
            }

            .des {
                @include font(rgba(145, 145, 145, 1), 12px, 400);
            }
        }
        .cover-image {
            display: block;
            width: 300px;
            height: 200px;
        }

        .icon-upload {
            font-size: 24px;
            color: rgba(0, 172, 188, 1);
            margin-bottom: 15px;
        }
    }

    &__content {
        flex: 1;
    }

    &__form {
        &-item {
            &:not(:first-child) {
                margin-top: 10px;
            }
        }
        .image-uploader__wrapper {
            overflow: hidden;
        }

        .form-btns {
            display: flex;
            margin-top: 30px;
        }
        .form-button {
            width: 120px;
            height: 40px;
            margin-right: 20px;
        }
        .icon-upload {
            font-size: 24px;
            color: rgba(0, 172, 188, 1);
        }
    }
}

// 小屏
@include mq($small) {
    .upload-works {
        padding-top: 15px;

        &__title {
            height: 30px;
            line-height: 30px;
        }

        .aside {
            width: 225px;
            margin-right: 18px;

            .cover-uploader__wrapper {
                width: 225px;
                height: 150px;
            }
            .cover-image {
                width: 225px;
                height: 150px;
            }

            .icon-upload {
                font-size: 18px;
            }
        }

        &__form {
            .icon-upload {
                font-size: 18px;
            }
        }
    }
}
</style>
